import { fetchAuthSession, type GetCurrentUserOutput } from "aws-amplify/auth";
import { Client, fetchExchange, gql } from "@urql/core";

import { subscriptions, type Subscription } from "../store";

const SUBSCRIPTION_QUERY = gql`
  query getSubscriptions {
    user: getUser {
      subscriptions {
        id
        reference
        startDate
        endDate
        billFrequency
        status
        sku
      }
    }
  }
`;

export const setSubscriptionsOnAuthChange = async (
  user: GetCurrentUserOutput | null,
) => {
  if (user) {
    const authSession = await fetchAuthSession();
    const idToken = authSession.tokens?.idToken?.toString();

    if (idToken) {
      const client = new Client({
        url: import.meta.env.PUBLIC_USER_ACCOUNT_API_URL,
        fetchOptions: () => {
          return {
            headers: {
              authorization: idToken,
            },
          };
        },
        exchanges: [fetchExchange],
      });

      const { data, error } = await client
        .query<{
          user: { subscriptions: Subscription[] };
        }>(SUBSCRIPTION_QUERY, {})
        .toPromise();

      if (error) {
        console.error(
          "Unable to determine the users current subscriptions",
          error,
        );
      }

      if (data) {
        subscriptions.set(data.user.subscriptions);
      }
    }
  }
};
